export default __webpack_public_path__ + "static/media/smallRoom.05d729fe.jpeg";